<template>
  <div class="summary-box">
    <div class="m-disabled-box" v-if="!enablePlaceOrder"></div>
    <b-container>
      <b-row>
        <b-col class="summary-head"><h4>Contact Information</h4></b-col>
      </b-row>
      <b-row>

      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">First Name(*): </b-col>
        <b-col lg="7">
          <b-input :value = "orderContact.FirstName"
                   @input.native="updateContact('FirstName', $event)"
                   size="sm"></b-input>
          <p class="m-error-text" v-if="showError && !orderContact.FirstName">Required</p>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">Last Name(*):</b-col>
        <b-col lg="7">
          <b-input :value = "orderContact.LastName"
                   @input.native="updateContact('LastName', $event)"
                   size="sm"></b-input>
          <p class="m-error-text" v-if="showError && !orderContact.LastName">Required</p>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">Country(*):</b-col>
        <b-col lg="7">
          <b-form-radio-group v-model ="orderContact.CountryCode">
            <b-form-radio value="US">USA</b-form-radio>
            <b-form-radio value="CA">Canada</b-form-radio>
          </b-form-radio-group>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">Address(*):</b-col>
        <b-col lg="7">
          <b-input :value = "orderContact.AddressLine"
                   @input.native="updateContact('AddressLine', $event)"
                   size="sm"></b-input>
          <p class="m-error-text" v-if="showError && !orderContact.AddressLine">Required</p>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">City(*):</b-col>
        <b-col lg="7">
          <b-input :value = "orderContact.City"
                   @input.native="updateContact('City', $event)"
                   size="sm"></b-input>
          <p class="m-error-text" v-if="showError && !orderContact.City">Required</p>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">State(*):</b-col>
        <b-col lg="7">
          <b-form-select :value = "orderContact.State" @change.native="updateContact('State', $event)">
            <option v-for = "item in $store.state.geo.states"
                    :value="item.code">
              {{item.code}}
            </option>
          </b-form-select>

          <p class="m-error-text" v-if="showError && !orderContact.State">Required</p>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">Zip(*):</b-col>
        <b-col lg="7">
          <b-input :value = "orderContact.Zipcode"
                   @input.native="updateContact('Zipcode', $event)"
                   size="sm"></b-input>

          <p class="m-error-text" v-if="showError && !orderContact.Zipcode">Required</p>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">Phone(*):</b-col>
        <b-col lg="7">
          <b-input :value = "orderContact.Phone"
                   @input.native="updateContact('Phone', $event)"
                   size="sm"></b-input>
          <p class="m-error-text" v-if="showError && !orderContact.Phone">Required</p>
        </b-col>
      </b-row>
    </b-container>
  </div>

</template>

<script>
  export default {
    components: {},
    data () {
      return {}
    },
    watch: {},
    created () {

    },
    methods: {
      updateContact (key, e) {
        this.$store.commit('order/updateContactInformation', {
          key: key,
          val: e.target.value
        })
      },
      updateOrderDesc (e) {
        this.$store.commit('order/saveKey', ['OrderDesc', e.target.value])
      }
    },
    computed: {
      order () {
        return this.$store.state.order
      },
      orderContact () {
        return this.$store.state.order.OrderContactInformation || {}
      },
      showError () {
        return this.$store.getters['summary/showError']
      },
      enablePlaceOrder () {
        return this.$store.getters['site/enablePlaceOrder']
      }
    }
  }
</script>

<style scoped lang="scss">
.item {
  padding-top: 8px;
  font-size: 13px;
}
.item-title {
  padding-right: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/MContactInformation.vue